import React, { Component } from 'react';
import FilterBasic from '../../basicElement/FilterBasic';
import API_URL from '../../../common/url';
import moment from 'moment';

class Filter extends Component {
    handleChange = (params, key) => {
        if (key === 'lineOfBusiness') {
            params.secondLineName = undefined;
            this.props.onChange(params, key);
        } else {
            this.props.onChange(params, key);
        }
    }

    render() {
        const { params, endMonth, startMonth, businessList, contractTypeList, signingUnitOptions, belongingToUnitOptions, ...rest } = this.props;
        const { lineOfBusiness } = params;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const secondLineOption = [...secondLineSet].map(i => ({ value: i, label: i }));
        const filters = [{
            name: '中心收入确认时间',
            key: 'date',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
                disabledDate: current => current && (current.valueOf() < moment(startMonth).valueOf() || current.valueOf() > moment(endMonth).valueOf())
            }
        }, {
            name: '项目简称',
            key: 'investigation',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'investigationName',
                style: {width: 160},
                placeholder: '输入名称检索',
                params: {limit: 20},
                url: API_URL.investigation.queryInvestigationByName,
                config: { id: 'investigationId', name: 'investigationName' }
            }
        }, {
            name: '中心',
            key: 'hospital',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'hospitalName',
                style: {width: 160},
                placeholder: '输入医院名称检索',
                params: {limit: 20 },
                url: API_URL.hospital.list,
                config: { id: 'hospitalId', name: 'hospitalName' },
            }
        }, {
            name: '科室',
            key: 'departmentName',
            type: 'input',
        }, {
            name: '区域/城市',
            key: 'areaCity',
            type: 'selectAreaCity',
        }, {
            name: 'JDE主项目号',
            key: 'jdeMainCode',
            type: 'input',
        }, {
            name: 'JDE项目号',
            key: 'jdeCode',
            type: 'input',
        }, {
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption
            }
        }, {
            name: '执行业务线二级分类',
            key: 'secondLineName',
            type: 'select',
            typeProperty: {
                disabled: !lineOfBusiness,
                list: secondLineOption,
            }
        }, {
            name: 'PM',
            key: 'pm',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.investigation.queryUserByKey,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: 'PM主管',
            key: 'pmLeader',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.investigation.queryUserByKey,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '领域leader',
            key: 'fieldLeader',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.user.queryLeaderList,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }];
        return (
            <FilterBasic filters={filters} params={params} {...rest} onChange={this.handleChange} />
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/financeManagement/centerIncomeReport/Filter.js